// =============================================================================
// TODO: REMOVE AFTER #27 DEBUG — DragDebugOverlay (issue #5 Phase R)
// URL クエリ `?debug=1` または localStorage('omakase-unshi:debug:drag')='1' で有効化。
// pointer event 発火履歴 (max 12 行) を画面右上に表示する。
// FingeringEditorPage から issue #17 Phase 2 で抽出。
// =============================================================================
import React, { useEffect, useState } from 'react';
import { dragDebugLog, dragDebugListeners, isDragDebugEnabled } from './dragDebug';

const DragDebugOverlay: React.FC = () => {
  const [enabled] = useState<boolean>(() => isDragDebugEnabled());
  const [, force] = useState(0);
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    const listener = () => force((n) => n + 1);
    dragDebugListeners.add(listener);
    return () => {
      dragDebugListeners.delete(listener);
    };
  }, [enabled]);
  if (!enabled) return null;
  return (
    <div
      data-testid="drag-debug-overlay"
      style={{
        position: 'fixed',
        top: 4,
        right: 4,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.78)',
        color: '#0f0',
        font: '10px/1.25 ui-monospace, SFMono-Regular, monospace',
        padding: '4px 6px',
        borderRadius: 4,
        maxWidth: '70vw',
        pointerEvents: 'auto',
        userSelect: 'text',
      }}
    >
      <button
        type="button"
        onClick={() => setCollapsed((v) => !v)}
        style={{
          all: 'unset',
          cursor: 'pointer',
          color: '#ffe28a',
          fontWeight: 700,
          marginBottom: 2,
          display: 'block',
        }}
      >
        {collapsed ? '▶ drag-debug' : '▼ drag-debug (tap to collapse)'}
      </button>
      {!collapsed && (
        <div>
          {dragDebugLog.length === 0 && (
            <div style={{ color: '#888' }}>(まだイベント無し)</div>
          )}
          {dragDebugLog.map((e, i) => (
            <div
              key={`${e.ts}-${i}`}
              style={{
                background: e.highlight ? 'rgba(255,80,80,0.35)' : 'transparent',
                padding: '0 2px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {e.text}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DragDebugOverlay;
